// import { React } from "react";
import { ListItem, Text, UnorderedList, Box } from "@chakra-ui/react";

const FourthFAQ = () => {
  return (
    <Box fontFamily="inherit" fontSize="inherit">
      <Text my="8px">
        Durata unui proces terapeutic poate varia semnificativ în funcție de mai
        mulți factori, inclusiv natura problemei pentru care cineva solicită
        ajutorul, frecvența sesiunilor, răspunsul individual la terapie și
        metoda terapeutică utilizată. Este important să înțelegi că terapia nu
        este o soluție rapidă și că durata poate fi influențată de complexitatea
        problemei și de obiectivele stabilite. Unele aspecte de luat în
        considerare în ceea ce privește durata terapiei includ:
      </Text>
      <UnorderedList>
        <ListItem>
          <strong>Problema sau tulburarea: </strong>Problemele mai complexe sau
          tulburările psihologice pot necesita mai mult timp pentru a fi
          abordate și rezolvate. Terapia pentru probleme de lungă durată, cum ar
          fi tulburările de anxietate sau depresie, poate dura mai mult.
        </ListItem>
        <ListItem>
          <strong>Frecvența ședințelor: </strong> Frecvența sesiunilor poate
          varia de la o săptămână la o dată pe lună sau chiar mai rar. Sesiunile
          regulate, mai ales la începutul terapiei, pot contribui la menținerea
          unui ritm continuu în proces.
        </ListItem>
        <ListItem>
          <strong>Răspunsul la terapie: </strong>Răspunsul individual la terapie
          este diferit pentru fiecare persoană. Unele persoane pot observa
          schimbări semnificative într-un interval relativ scurt, în timp ce
          altele pot avea nevoie de mai mult timp pentru a vedea rezultate.
        </ListItem>
        <ListItem>
          <strong>Limitarea duală: </strong>
          Psihoterapeuții trebuie să evite orice comportament care ar putea crea
          o confuzie în privința rolurilor lor, cum ar fi relațiile personale
          sau angajamentele în afara contextului terapeutic. Este important ca
          limitările să fie clar comunicate și menținute.
        </ListItem>
        <ListItem>
          <strong>Tipul de terapie: </strong>
          Diferitele tipuri de terapie pot avea abordări și durate diferite. De
          exemplu, terapia cognitiv-comportamentală (TCC) poate fi mai
          focalizată pe soluționarea problemelor pe termen scurt, în timp ce
          terapia psihodinamică poate implica o explorare mai profundă și mai
          lungă a istoricului emoțional al unei persoane.
        </ListItem>
        <ListItem>
          <strong>Obiectivele stabilite: </strong>Durata terapiei poate fi
          influențată de obiectivele specifice stabilite între terapeut și
          client. Obiectivele realiste și clare pot contribui la stabilirea unei
          direcții și la măsurarea progresului.
        </ListItem>
      </UnorderedList>
      <Text my="8px">
        Este important să discuți cu terapeutul tău despre așteptările și
        planurile pentru terapie. Terapeutul poate oferi o estimare mai
        detaliată bazată pe evaluarea inițială și pe progresul realizat în
        timpul ședințelor. În plus, terapia poate implica diferite etape, iar
        unele persoane pot alege să continue cu terapie de întreținere sau să
        revină pentru terapie în perioade ulterioare, chiar și după atingerea
        obiectivelor inițiale.
      </Text>
    </Box>
  );
};

export default FourthFAQ;
